export default "__VITE_ASSET__zFf3Lth2__"